import {Reducer} from "redux";
import {IApplicationState, ILayerState} from "../types";
import {fromJS} from "immutable";
import {createSource} from "../../utils/createSource";
import {createFeatureCollection} from "../../utils/createFeatureCollection";
import {insertLayer} from "./insertLayer";
import {IFeature_Collection_CONO} from "../../types";

interface ILayer {
    layerId: number;
    type: string;
    geoType: string;
    layername: string;
}

const reducer: Reducer<IApplicationState['map']> = (state, action) => {
    const layerState: ILayerState = {...state?.layerState};
    let mapStyle = state?.mapStyle;
    const databaseLayerIds = {...state?.databaseLayerIds};
    const layerIds = state?.layerIds.slice();
    const layer: ILayer = action.payload;
    const layerType = layer.type;
    const geoType = layer.geoType;
    layerState[layerType] = createLayerState(layer.layername, {layerType, geoType});
    databaseLayerIds[layerType] = layer.layerId;
    // create feature source
    mapStyle = mapStyle?.setIn(['sources', layerType], fromJS(
            createSource(
                createFeatureCollection([]) as any as IFeature_Collection_CONO
            )
        )
    );
    mapStyle = insertLayer(mapStyle!, layerType, geoType);
    layerIds?.push(layerType);
    return {...state, layerIds, layerState, databaseLayerIds, mapStyle} as IApplicationState['map'];
};


function createLayerState (name: string, attributes: {[key: string]: string|number}): any {
    return {
        visibility: 'none',
        name,
        ...attributes
    }
}

export { reducer as createNewLayer };
